import StaffPerformanceCSVPreviewBaseColumnsStrategy from './StaffPerformanceCSVPreviewBaseColumnsStrategy'

export default function StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy() {}

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype = Object.create(StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype)

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.init = function(includeOtherUsersColumn, groupMessageProvider) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.init.call(this, includeOtherUsersColumn)
    this.groupMessageProvider = groupMessageProvider
    return this
}


StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.addMainHeaderRowCells = function(mainHeaderRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells.call(this, mainHeaderRow)

    let colTitle = this.message(this.groupMessageProvider.getGroupNameSingularKey())

    this.addCell(mainHeaderRow, colTitle)
    this.addCell(mainHeaderRow, colTitle)
    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"))
}

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function(colGroupingRow) {
    //do nothing
}

StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.getNumOfDataColumns = function() {
    return this.includeOtherUsersColumn ? 4 : 3
}






// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.js